import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-card" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-500-bold" }, " This screen contains a repository of messages you’ve previously viewed which are stored here for historic reference ")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "col-md-12 text-center mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "alerts-wrapper"
}
const _hoisted_5 = { class: "alerts-cards" }
const _hoisted_6 = { class: "bordered-card-header" }
const _hoisted_7 = { class: "text-grey" }
const _hoisted_8 = { class: "bordered-card-body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 3,
  class: "row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 text-center mb-4" }, " No archived alerts", -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : ($setup.alerts.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alerts, (alert) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "bordered-card",
                  key: alert.AlertID
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString($setup.useDateFormatter(alert.DateCreated)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", {
                      innerHTML: alert.Message
                    }, null, 8, _hoisted_9)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
  ]))
}